<template>
  <div>
    <div class="step-title">设置新密码</div>

    <a-form-model ref="formRef" :model="form" :rules="rules" layout="vertical">
      <a-form-model-item prop="password">
        <a-input-password v-model="form.password" placeholder="请输入密码">
          <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }" />
        </a-input-password>
      </a-form-model-item>

      <a-form-model-item prop="confirmPassword">
        <a-input-password v-model="form.confirmPassword" placeholder="确认密码">
          <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }" />
        </a-input-password>
      </a-form-model-item>

      <a-form-model-item class="submit-item">
        <a-button
          size="large"
          block
          :disabled="submitLoading"
          @click="$emit('prev')"
        >
          上一步
        </a-button>
        <a-button
          type="primary"
          size="large"
          block
          :loading="submitLoading"
          :disabled="submitLoading"
          @click="handleNext"
        >
          下一步
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      required: true,
    },
    rules: {
      type: Object,
      required: true,
    },
    submitLoading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleNext() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.$emit("next");
        }
      });
    },
    resetForm() {
      this.$refs.formRef && this.$refs.formRef.resetFields();
    },
  },
};
</script>

<style scoped>
.step-title {
  margin-bottom: 28px;
  font-size: 18px;
  text-align: center;
  color: #333;
}

.submit-item {
  margin-top: 8px;
  margin-bottom: 0;
}

.submit-item /deep/ .ant-form-item-children {
  display: grid;
  grid-template-columns: 120px 1fr;
  gap: 12px;
}
</style>
